module.exports = __webpack_public_path__ + "static/media/img35.470b8c9a.jpg";